export const supplierCatalogIntegers = [];
export const supplierCatalogFloats = [];
export const supplierCatalogIsoStrings = [];
export const supplierCatalogWhiteList = ['id', 'name', 'supplierId'];
export const supplierCatalogOptimisticList = [
  ...supplierCatalogWhiteList,
  'supplierCatalogItems',
  'supplier',
];
